export const IdeaIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 27 48">
      <path
        fill="#ECEFF0"
        stroke="#151415"
        strokeMiterlimit="10"
        strokeWidth="0.75"
        d="M13.423.99v8.272c-.417-.332-.974-.523-1.577-.523-1.438 0-2.598 1.189-2.598 2.663 0 1.474 1.16 2.662 2.598 2.662.603 0 1.113-.19 1.577-.523v5.943h4.362c-.325-.428-.51-.999-.51-1.617 0-1.474 1.16-2.662 2.598-2.662s2.598 1.188 2.598 2.662a2.79 2.79 0 01-.51 1.617h3.48a13.492 13.492 0 001.02-5.135C26.415 6.98 20.615.99 13.423.99z"
      ></path>
      <path
        fill="#FF9650"
        stroke="#151415"
        strokeMiterlimit="10"
        strokeWidth="0.75"
        d="M11.846 14.064c-1.438 0-2.598-1.188-2.598-2.662s1.16-2.663 2.598-2.663c.603 0 1.113.19 1.577.523V.99C6.232.99.433 6.885.386 14.254c0 1.854.37 3.613 1.02 5.23h4.037c-.325.427-.51.998-.51 1.616 0 1.474 1.16 2.662 2.598 2.662s2.598-1.188 2.598-2.662a2.78 2.78 0 00-.51-1.616h3.804V13.54a2.733 2.733 0 01-1.577.523z"
      ></path>
      <path
        fill="#000"
        d="M19.27 38.595c-.047-.285-.28-.523-.604-.475l-5.243.57-5.382.618c-.278.048-.51.285-.464.618.047.285.279.523.603.476l10.625-1.189c.279 0 .51-.285.464-.618zm0 1.569c-.047-.285-.28-.523-.604-.475L8.041 40.877c-.278.048-.51.285-.464.618.047.285.279.523.603.476l10.625-1.189c.279-.047.51-.285.464-.618zm-.372 2.187L7.995 43.587c-.232.048-.418-.143-.464-.38l-.046-.286c-.047-.237.139-.427.37-.475L18.76 41.21c.232-.048.418.143.464.38l.047.285c.046.238-.14.428-.372.476zm-.974 1.664c0 1.759-1.995 3.185-4.5 3.185-2.506 0-4.501-1.426-4.501-3.185h9z"
      ></path>
      <path
        fill="#000"
        d="M8.923 44.015l9-.903v.903h-9zm-.974-6.799l.185 1.57 9.697-1.047-8.351-.095-.882-.047-.65-.38z"
      ></path>
      <path
        fill="#0C75D7"
        d="M21.96 19.531c.325-.428.51-.998.51-1.616 0-1.474-1.16-2.662-2.598-2.662s-2.598 1.188-2.598 2.662c0 .618.186 1.14.51 1.616h-4.36v6.799c.417-.333.974-.523 1.577-.523 1.438 0 2.598 1.188 2.598 2.662s-1.16 2.662-2.598 2.662c-.603 0-1.114-.19-1.578-.523v7.036H17.6c.928 0 1.763-.618 2.088-1.52l5.707-16.593H21.96z"
      ></path>
      <path
        stroke="#000"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.75"
        d="M21.96 19.531c.325-.428.51-.998.51-1.616 0-1.474-1.16-2.662-2.598-2.662s-2.598 1.188-2.598 2.662c0 .618.186 1.14.51 1.616h-4.36v6.799c.417-.333.974-.523 1.577-.523 1.438 0 2.598 1.188 2.598 2.662s-1.16 2.662-2.598 2.662c-.603 0-1.114-.19-1.578-.523v7.036H17.6c.928 0 1.763-.618 2.088-1.52l5.707-16.593H21.96z"
      ></path>
      <path
        fill="#fff"
        stroke="#151415"
        strokeMiterlimit="10"
        strokeWidth="0.75"
        d="M14.954 31.131c1.438 0 2.598-1.188 2.598-2.662s-1.16-2.662-2.598-2.662c-.603 0-1.113.19-1.577.523v-6.8H9.572c.325.428.51.999.51 1.617 0 1.473-1.16 2.662-2.598 2.662s-2.598-1.189-2.598-2.662c0-.618.186-1.141.51-1.617h-3.99l5.707 16.592c.325.903 1.16 1.521 2.088 1.521h4.176v-7.036c.464.333 1.02.523 1.577.523z"
      ></path>
    </svg>
  );
};
